exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.label[data-v-31d26e1c]{font-weight:bold\n}\n.pad5[data-v-31d26e1c]{padding:25px 10px\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/screens/central/cadastros/para/areasPatrimoniais/components/Resumo.vue"],"names":[],"mappings":";AA6DA,wBACE,gBAAiB;CAClB;AAAA,uBAEC,iBAAkB;CACnB","file":"Resumo.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.label {\n  font-weight: bold;\n}\n.pad5 {\n  padding: 25px 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31d26e1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/para/areasPatrimoniais/components/Resumo.vue
// module id = iCyE
// module chunks = 12